type Size = {width: number; height: number};

/**
 * Where a rendered composition goes on the preview photo. The BE saves a composition watermark as
 * center_center, size 100, fitToImage: the photo keeps its own size, and the watermark is scaled
 * to fit inside the photo with its aspect kept and is centered on it.
 */
export const getCompositionPlacement = (photo: Size, watermark: Size) => {
  const scale = Math.min(photo.width / watermark.width, photo.height / watermark.height);
  const width = watermark.width * scale;
  const height = watermark.height * scale;

  return {
    x: (photo.width - width) / 2,
    y: (photo.height - height) / 2,
    width,
    height,
  };
};
